<template>
  <el-menu
    mode="vertical"
    unique-opened
    :default-active="routePath"
    background-color="#304156"
    text-color="#fff"  @select="handleSelect"
  >
    <sidebar-item :routes="menuData"></sidebar-item>
  </el-menu>
</template>

<script>
import sidebarItem from './sidebarItem'

export default {
  data() {
    return {
      menuData: [],
      routePath: this.$route.path
    }
  },
  components: { sidebarItem },
  computed: {
    routes() {
      return this.menuData
    }
  },
  watch: {
    $route() {
      this.setBtnPermissions()
    }
  },
  created() {
    // this.menuData = JSON.parse(localStorage.getItem("menuData"));
    let routePath = this.$route.path.split('')
    let length = 0
    const that = this
    let Index = 0
    routePath.forEach(function(item, index) {
      if (item === '/') {
        length++
        if (length === 3) {
          Index = index
        }
      }
    })
    that.routePath = length === 3 ? that.$route.path.substr(0, Index) : that.$route.path
    this.getAreaList()
    this.getMenuByRoleId()
  },
  methods: {
    handleSelect() {
      localStorage.setItem('pageNo', 1)
      localStorage.setItem('type', 0)
    },
    getMenuByRoleId() {
      WAPI.getMenuByRoleId({}).then((menuData) => {
        switch (menuData.code) {
          case 200:
            this.menuData = menuData.data
            localStorage.setItem('menuData', JSON.stringify(this.menuData))
            if (!this.commonApi.isNull(this.menuData) && this.menuData.length > 0) {
              this.setBtnPermissions()
            } else {
              this.$router.push({ path: '/login' })
            }
            break
        }
      })
    },
    setBtnPermissions() {
      this.commonApi.setPermissionUrl(this, this.menuData, '按钮权限')
    },
    getAreaList() {
      WAPI.getAreaList({}).then((data) => {
        switch (data.code) {
          case 200:
            this.$store.commit('setAreaData', data.data)
            break
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/sidebar/index.vue